import { RowsControl } from 'legacy/lut/components/widgets/public/partner360/ELT/ui/styledComponents/rowsControl/RowsControl'
import { Header } from 'legacy/lut/components/widgets/public/partner360/ELT/ui/styledComponents/styledTable/Header'
import { TableTitle } from 'legacy/lut/components/widgets/public/partner360/ELT/ui/styledComponents/styledTable/TableTitle'
import { memo } from 'react'

import { Rows } from './Rows'
import { IColumn } from './types'

import styles from './StyledTable.module.scss'

export interface ITableClasses {
  td?: string
  header?: string
  deleteIcon?: string
  tr?: string
}

export interface IHeaderGroup {
  colspan: number
  name: string
  withoutBorder?: boolean
}

interface IProps<T> {
  columns: IColumn<T>[]
  title?: string
  items: T[]
  addRow?: () => void
  deleteLastRow?: () => void
  deleteRow?: (index: number) => void
  maxLen?: number
  canAddNewRow?: boolean
  keyField?: string
  classes?: ITableClasses
  headerGroups?: IHeaderGroup[]
}
const genericMemo: <T>(component: T) => T = memo
function StyledTableComponent<T>({
  columns,
  title,
  items,
  addRow,
  deleteLastRow,
  deleteRow,
  maxLen,
  canAddNewRow,
  keyField,
  classes = {} as ITableClasses,
  headerGroups,
}: IProps<T>) {
  return (
    <div className={styles.root}>
      <TableTitle title={title} />

      <table className={styles.table}>
        <Header<T> columns={columns} headerGroups={headerGroups} className={classes?.header} />
        <tbody>
          <Rows<T>
            columns={columns}
            items={items}
            deleteRow={deleteRow}
            keyField={keyField}
            classes={classes}
          />
        </tbody>
      </table>

      <RowsControl<T>
        addRow={addRow}
        deleteRow={deleteLastRow}
        maxLen={maxLen}
        items={items}
        canAddNewRow={canAddNewRow}
      />
    </div>
  )
}
export const StyledTable = genericMemo(StyledTableComponent)
